import React from 'react';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import Testimonial from '../components/home/Testimonial';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <Testimonial />
    </>
  );
};

export default Home;
